/**
 * @generated SignedSource<<548bc81f57d1388938c9a24d93632b90>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type WidgetIssueSummaryIssueCreatedSubscription$variables = {
  teamIds: ReadonlyArray<string>;
};
export type WidgetIssueSummaryIssueCreatedSubscription$data = {
  readonly issueCreated: {
    readonly store: {
      readonly teams: ReadonlyArray<{
        readonly unresolvedIssueCount: number;
      }>;
    };
  } | null;
};
export type WidgetIssueSummaryIssueCreatedSubscription = {
  response: WidgetIssueSummaryIssueCreatedSubscription$data;
  variables: WidgetIssueSummaryIssueCreatedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "teamIds",
    "variableName": "teamIds"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "teamIds"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unresolvedIssueCount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetIssueSummaryIssueCreatedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Issue",
        "kind": "LinkedField",
        "name": "issueCreated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "store",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WidgetIssueSummaryIssueCreatedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Issue",
        "kind": "LinkedField",
        "name": "issueCreated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "store",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "549171e9e0b6c84fb40ce9a715efa2d6",
    "id": null,
    "metadata": {},
    "name": "WidgetIssueSummaryIssueCreatedSubscription",
    "operationKind": "subscription",
    "text": "subscription WidgetIssueSummaryIssueCreatedSubscription(\n  $teamIds: [ID!]!\n) {\n  issueCreated(teamIds: $teamIds) {\n    store {\n      teams(ids: $teamIds) {\n        unresolvedIssueCount\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "decafb38ac51abd05fabd306aa38fcb1";

export default node;
